export const formatComboError = (error: Error) => {
  const isInsufficientLiquidityError = error.message.includes(
    "LIQUIDITY_INSUFFICIENT",
  );
  if (isInsufficientLiquidityError) {
    const { message } = JSON.parse(error.message);
    return message;
  }

  const isDuplicateInstrumentError = error.message.includes(
    "market_orders/uniqueItemProperties",
  );
  if (isDuplicateInstrumentError) {
    return "Duplicated instrument not allowed in combo";
  }

  try {
    const { message } = JSON.parse(error.message);
    return message;
  } catch {
    return error.message;
  }
};
